import React from 'react'
import classNames from 'classnames';

export const Pagination = ({ totalList, page, changePage }) => {
  return (
    <nav className="mt-5">
        <ul className="pagination justify-content-center">
            <li className="page-item"><a className="page-link" href="javascript:;" onClick={() => changePage(page - 1)}>&laquo;</a></li>
            {
                totalList?.map((value, id) =>
                    <li key={id} onClick={() => changePage(id + 1)} className={classNames("page-item", {
                        active: page === (id + 1)
                    })}><a className="page-link" href="javascript:;">{id + 1}</a></li>
                )
            }
            <li className="page-item"><a className="page-link" href="javascript:;" onClick={() => changePage(page + 1)}>&raquo;</a></li>
        </ul>
    </nav>
  )
}
